import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import analyticsService from "../../../services/analytics/analyticsService";
import EWallet from "../../../components/EWallet/EWallet";
import Header from "../../../components/Header/Header";
import useGetWalletTransaction from "../../../hooks/useGetWalletTransaction";
import eWalletInfo from "../../../interfaces/ewallet-info";
import transactionInfo from "../../../interfaces/transaction-info";
import styles from "./EwalletRefundSale.module.scss";

function EwalletRefundSale(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const [refundAmt, setRefundAmt] = useState<number>(0);
  const [listTransactions] = useGetWalletTransaction();
  const [transactions, setTransaction] = useState<transactionInfo[]>([]);
  const [transactionId, setTransactionId] = useState<number>(0);


  let dumble = new analyticsService();
  


  // need to get transactions
  const {
    amount, grade, id, studentFirstName, studentLastName,
    teacherFirstName, teacherLastName,
  } = location.state as eWalletInfo;

  const item: eWalletInfo = {
    amount,
    grade,
    id,
    studentFirstName,
    studentLastName,
    teacherFirstName,
    teacherLastName,
  };

  const walletTransactions = async () => {
    const { data, error } = await listTransactions(id);
    if (error) {
      console.log(error);
    } else if (data != null) {
      setTransaction(data);
    }
  };

  useEffect(() => {
    walletTransactions();
    dumble.initDumblePage("Payment Portal:eWallet:Refund Amount");
  }, []);

  const createTime = (time:string) => {
    let timer;
    const final = `${time.substring(5, 7)}/${time.substring(8, 10)}/${time.substring(0, 4)}`;
    if (parseInt(time.substring(11, 13), 10) > 12) {
      timer = `${parseInt(time.substring(11, 13), 10) % 12}:${time.substring(14, 16)}PM`;
    } else {
      timer = `${time.substring(11, 13)}:${time.substring(14, 16)}AM`;
    }
    const info = `${final}, ${timer}`;
    return info;
  };

  // details about the sale
  const actualInfo = (info: any) => (
    <div className={styles.refundInfo}>
      <div className={styles.time}>
        <div className={styles.sale}>Sale </div>
        <div> &nbsp; | &nbsp; </div>
        <div className={styles.createtime}>
          {createTime(info.createdOn)}
        </div>
      </div>
      <div className={styles.amount}>
        -$
        {parseFloat(info.refundableAmount).toFixed(2)}
      </div>
    </div>
  );

  const createRadio = (sales: any) => (
    <div>
      <label htmlFor="refundRadio">
        <input
          type="radio"
          name="radioChoice"
          value={sales.amount}
          onClick={() => {
            setRefundAmt(sales.refundableAmount);
            setTransactionId(sales.id);
          }}
        />
        {actualInfo(sales)}
      </label>
      <div className={styles.partialText}>
        {sales.refundableAmount !== sales.saleAmount ? "Partially Refunded" : null}
      </div>
      <div className={styles.linebreak}></div>
    </div>

  );

  // include 'partially refunded'
  const displayTransactions = () => {
    return (
      <div>
        {transactions.map((item: any) =>
          {
            if (item.refundableAmount !== 0){
              return createRadio(item);
            }
          })
        }
      </div>
    );
  };

  const navigateToeWalletReview = () => {
    navigate(
      "/ewalletrefund/review.html",
      {
        state:
      {
        refundAmt,
        amount,
        grade,
        id,
        studentFirstName,
        studentLastName,
        teacherFirstName,
        teacherLastName,
        transactionId,
      },
      },
    );
  };

  return (
    <div className={styles.EwalletRefundSale} data-testid="EWalletRefundAmount">
      <Header name="Choose Transaction" redirect="/ewalletrefund.html" />
      <div className={styles.EwalletWrapper}>
        <div className={styles.responsive}>
          <div className={styles.ewallet}>
            <EWallet item={item} payment={false} className={styles.ewallet} />
          </div>
          <div className={styles.EwalletTransaction}>
              <h3>Choose Transaction</h3>
              <h5>Can only refund payments made in Payment Portal</h5>
            {displayTransactions()}
          </div>
        </div>
        <button
          type="submit"
          onClick={navigateToeWalletReview}
          id="submitButton"
          disabled={refundAmt === 0}

        >
          CHOOSE AMOUNT
        </button>
        <br/>
        <br/>
      </div>
    </div>
  );
}

export default EwalletRefundSale;
